import { Host } from './Host';
import styles from './HostImageStack.module.scss';
import { HostImage } from './HostImage';

const IMAGE_WIDTH = 25;
const OVERLAP = 0.35;
const OFFSET = Math.round(IMAGE_WIDTH * OVERLAP);

interface Props {
  hosts: Host[];
}

export const HostImageStack: React.FC<Props> = ({ hosts }) => {
  const availableHostsImages = hosts.filter((host: Host) => host.image?.url);

  if (availableHostsImages.length === 0) {
    return null;
  }

  return (
    <div className={styles.stack}>
      {availableHostsImages.map((host: Host, i: number) => (
        <HostImage
          key={host.name}
          host={host}
          style={{ marginLeft: i === 0 ? 0 : -OFFSET, zIndex: hosts.length - i }}
        />
      ))}
    </div>
  );
};
